const SESSION_ONLY = "@sacgpt:session-only";
const AUTH_KEYS = ["@sacgpt:token", "@sacgpt:user"];

const activeStorage = () => sessionStorage.getItem(SESSION_ONLY) === "true"
  ? sessionStorage
  : localStorage;

const authStorage = {
  getItem: key => activeStorage().getItem(key),
  setItem: (key, value) => activeStorage().setItem(key, value),
  removeItem: key => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  },
  setPersistence: rememberMe => {
    const previousStorage = rememberMe ? sessionStorage : localStorage;
    AUTH_KEYS.forEach(key => previousStorage.removeItem(key));
    if (rememberMe) sessionStorage.removeItem(SESSION_ONLY);
    else sessionStorage.setItem(SESSION_ONLY, "true");
  },
  clear: () => {
    AUTH_KEYS.forEach(authStorage.removeItem);
    sessionStorage.removeItem(SESSION_ONLY);
  },
};

export default authStorage;
